import setShelters from './setShelters';
import setShelter from './setShelter';
import resetCurrentShelter from './resetCurrentShelter';

export default {
  setShelters,
  setShelter,
  resetCurrentShelter,
};
